import referralCodesTypes from "./referralCodesTypes";
import { PENDING, SUCCESS, ERROR } from "../../globalStatuses/globalStatuses";

const initialState = {
    items: [],
    pagination: { has_more: false, next_cursor: '', prev_cursor: '' },
    status: '',
    params: {
        phone: '',
        limit: 20,
        after: '',
        before: '',
    },
}

const referralCodesReducer = (state = initialState, action) => {
    switch (action.type) {
        case referralCodesTypes.GET_REFERRAL_CODES_PENDING:
            return { ...state, status: PENDING };
        case referralCodesTypes.GET_REFERRAL_CODES_SUCCESS:
            return {
                ...state,
                status: SUCCESS,
                items: action.payload?.items || [],
                pagination: action.payload?.pagination || { has_more: false, next_cursor: '', prev_cursor: '' },
            };
        case referralCodesTypes.GET_REFERRAL_CODES_ERROR:
            return { ...state, status: ERROR };
        case referralCodesTypes.SET_REFERRAL_CODES_PARAMS:
            return { ...state, params: { ...state.params, ...action.payload } };
        case referralCodesTypes.RESET_REFERRAL_CODES:
            return initialState;
        default:
            return state;
    }
}

export default referralCodesReducer;
